import { useState } from 'react';

import { Popover } from '@bambi/component-library/src/components/Popover/Popover';
import { ChevronDownIcon } from '@heroicons/react/24/solid';

import { useFeature } from 'src/app/FeatureToggle';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { useUserRoles } from 'src/features/auth/useUserRoles';

import { onRunBambiRunShouldMultiloadChange } from '../dispatcher.slice';

export function RunBambiRunButtonPopover() {
  const dispatch = useAppDispatch();

  const { isBambi } = useUserRoles();

  const { isEnabled: isMultiloadEnabled } = useFeature(
    'run bambi run multiloading'
  );

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const runBambiRunShouldMultiload = useAppSelector(
    (state) => state.dispatcher.runBambiRunShouldMultiload
  );

  const showMultiloadPopover = isMultiloadEnabled || isBambi;

  const getMenuItemClassName = (isSelected: boolean) => {
    return `${
      isSelected ? 'bg-gray-200' : ''
    } cursor-pointer rounded-md p-2 hover:bg-gray-300`;
  };

  return (
    <>
      {showMultiloadPopover && (
        <div className="inline-flex">
          <div className="absolute right-0 top-1/2 -translate-y-1/2 border-l border-white/30">
            <Popover
              open={isPopoverOpen}
              onOpenChange={setIsPopoverOpen}
              trigger={
                <button
                  data-testid="run-bambi-run-button-popover-trigger"
                  onClick={() => {
                    setIsPopoverOpen(!isPopoverOpen);
                  }}
                  className="relative inline-flex cursor-pointer items-center px-3 py-3 text-white"
                >
                  <ChevronDownIcon className="h-4 w-4 " />
                </button>
              }
              content={
                <div className="-m-3 flex flex-col gap-1 text-sm">
                  <div
                    data-testid="run-bambi-run-button-popover-item"
                    onClick={() => {
                      dispatch(onRunBambiRunShouldMultiloadChange(false));
                      setIsPopoverOpen(false);
                    }}
                    className={getMenuItemClassName(
                      !runBambiRunShouldMultiload
                    )}
                  >
                    Run Bambi Run
                  </div>
                  <div
                    data-testid="run-bambi-run-button-popover-item"
                    onClick={() => {
                      dispatch(onRunBambiRunShouldMultiloadChange(true));
                      setIsPopoverOpen(false);
                    }}
                    className={getMenuItemClassName(runBambiRunShouldMultiload)}
                  >
                    [Beta] Run Bambi Run Multiload
                  </div>
                </div>
              }
            />
          </div>
        </div>
      )}
    </>
  );
}
